import * as lodash from 'lodash';
import {ObjectSchema} from 'yup';
import {FieldErrors} from "react-hook-form/dist/types/errors";
import {TFunction} from "i18next";

/**
 * Uses the yup spec in the schema to get whether or not the field is required or not
 *
 * For inner objects, it creates a new property "__required" to contain the info if the whole sub structure is required or not
 */
export function makeRequired<T>(schema: ObjectSchema<T>): Record<keyof T, any> {
  const fields = (schema as any).fields;
  return Object.keys(fields).reduce((accu, field) => {
    if (fields[field].fields) {
      accu[field] = makeRequired(fields[field]);
      accu[field]["__required"] = !fields[field].spec.optional;
    } else {
      let fieldDef = fields[field];
      // console.info("Checking schema of field " + field + ": required=" + !fieldDef.spec.optional, fieldDef.spec);
      accu[field] = !fieldDef.spec.optional;
    }
    return accu;
  }, {} as any);
}

export function retrieveError<T>(name: string, errors?: FieldErrors<T>): string | undefined {
  // console.info('Retrieving error for ' + name + " from " + JSON.stringify(errors));
  const error = lodash.get(errors, name);
  // console.info('Error:' + JSON.stringify(error));
  return error?.message?.toString();
}

export interface MessageParams {
  path: string;
  value: any;
  originalValue: any;
  label: string;
  type: string;
}

/**
 * Returns a function that can be given into yup definitions to create localized error messages
 */
export function formError(t: TFunction, formErrorKey: string, i18nPrefix: string) {
  return (params: MessageParams) => {
    const path = params.path.replace('[0]', '');
    let fieldName = t(i18nPrefix + path);
    if (typeof fieldName === 'object') {
      fieldName = t(i18nPrefix + path + '.title');  // Use title if we had hit an object
    }
    return t("FormErrors." + formErrorKey, {field: fieldName}) as unknown
  }
}

export function submitForm(formId: string) {
  const element = window?.document?.getElementById(formId);
  element?.dispatchEvent(new Event('submit', {cancelable: true, bubbles: true}));
}
